import { useLocation } from 'react-router-dom';
import Spinner from '../atoms/spinner/spinner';
import Footer from './footer/footer';
import HamburgMenu from './hamburgMenu/hamburgMenu';
import Header from './header/header';
import styles from './layout.module.scss';
import NavBar from './navbar/nav-bar';

type Props = {
  children: JSX.Element | JSX.Element[];
};

const Layout = (props: Props) => {
 const { children } = props;
  const { pathname } = useLocation();

  const isWithoutLayout = ['/reset-password', '/login'].some(path => pathname.includes(path));

  return (
    <div className={styles.layoutContainer}>
      {!isWithoutLayout && <Header />}
      <div className={styles.bodyContainer}>
        {!isWithoutLayout && <HamburgMenu />}
        {!isWithoutLayout && <NavBar />}
        <div className={styles.childreWrapper}>{children}</div>
      </div>
      {!isWithoutLayout && <Footer />}
    </div>
  );
};

export default Layout;
